import { useEffect } from "react";
import { useDispatch } from "react-redux";

import SiteTitle from "../../../helpers/SiteTitle/SiteTitle";
import Icon from "../../../components/Icon/Icon";
import { clearAuthAction } from "../../../redux/actions/authActions/authActions";
import {
  BlockContent,
  BlockDes,
  BlockHead,
  BlockTitle,
} from "../../../components/Block/Block";
import { removeCookies } from "../../../utils";

const LogOutAuth = () => {
  const dispatch = useDispatch();

  const handleLogOut = async () => {
    await removeCookies("accessToken");
    dispatch(clearAuthAction());
  };

  useEffect(() => {
    handleLogOut();
  }, []);

  return (
    <>
      <SiteTitle title="خروج از حساب کاربری" />
      <BlockHead>
        <BlockContent className="text-center">
          <p>
            <Icon name="signout" className="fa-7x" />
          </p>
          <BlockTitle tag="h4">لطفا منتظر بمانید...</BlockTitle>
          <BlockDes className="text-muted">
            <p>شما درحال خروج از حساب کاربری می باشید</p>
          </BlockDes>
        </BlockContent>
      </BlockHead>
    </>
  );
};

export default LogOutAuth;
